import { render, staticRenderFns } from "./organization-member-delete-option-modal.vue?vue&type=template&id=c9608240&scoped=true&"
import script from "./organization-member-delete-option-modal.vue?vue&type=script&lang=js&"
export * from "./organization-member-delete-option-modal.vue?vue&type=script&lang=js&"
import style0 from "./organization-member-delete-option-modal.vue?vue&type=style&index=0&id=c9608240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9608240",
  null
  
)

export default component.exports